import { render, staticRenderFns } from "./customer_pool.vue?vue&type=template&id=07605e54&scoped=true"
import script from "./customer_pool.vue?vue&type=script&lang=js"
export * from "./customer_pool.vue?vue&type=script&lang=js"
import style0 from "./customer_pool.vue?vue&type=style&index=0&id=07605e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07605e54",
  null
  
)

export default component.exports